<template>
    <div>
        <div class="VueTables__primary-content">{{ title }}</div>
        <div class="VueTables__secondary-content" v-if="singleCourseStatus">
            {{ trans('reporting.label.assigned_at') }} {{ singleCourseStatus }}
        </div>
    </div>
</template>

<script>
import moment from 'moment';

export default {
    props: ['data', 'filter'],

    computed: {
        singleCourseStatus() {
            const { data, filter } = this;

            if (data.assignments.length === 1) {
                return data.assignments[0].status != 'not_assigned'
                    ? this.formatDate(data.assignments[0].assigned_at)
                    : '';
            }
            if (filter.filterByCourse) {
                const assignment =
                    data.assignments.find(
                        ({ course_id }) =>
                            course_id === filter.filterByCourse.id
                    ) || {};

                return assignment.status != 'not_assigned'
                    ? this.formatDate(assignment.assigned_at)
                    : '';
            }

            return '';
        },
        title() {
            const { data, filter } = this;

            if (filter.filterByCourse) {
                return filter.filterByCourse.label;
            }

            if (data.assignments.length > 1) {
                return (
                    data.assignments.length +
                    ' ' +
                    this.trans('assignments.overview.course_name')
                );
            }

            return data.assignments[0].course;
        },
    },
    methods: {
        formatDate(date) {
            return date ? moment(date).format('DD.MM.YYYY') : '-';
        },
    },
};
</script>
